import { render, staticRenderFns } from "./Polygons404.vue?vue&type=template&id=75b8585a&scoped=true&"
var script = {}
import style0 from "./Polygons404.vue?vue&type=style&index=0&id=75b8585a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b8585a",
  null
  
)

export default component.exports